/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductListSkuIdListResponse
 */
export interface ProductListSkuIdListResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductListSkuIdListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListSkuIdListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductListSkuIdListResponse
     */
    items: Array<string>;
}

/**
 * Check if a given object implements the ProductListSkuIdListResponse interface.
 */
// @ts-ignore
export function instanceOfProductListSkuIdListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListSkuIdListResponseFromJSON(json: any): ProductListSkuIdListResponse {
    return ProductListSkuIdListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListSkuIdListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListSkuIdListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': json['items'],
    };
}

// @ts-ignore
export function ProductListSkuIdListResponseToJSON(value?: ProductListSkuIdListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': value.items,
    };
}

